import cashboxApi from '@/api/cashbox';

const state = {
    opened: null,
    closed: null,
    acqClosed: null,
    list: null,
    cashbox: null,
    cashIn: null,
    cashOut: null,
    paid: null,
    data: null,
    isLoading: null,
    doingPayment: null,
    validationErrors: null,
    xReport: null,
    receipt: null,
    receiptCanceled: null,
    zReport: null,
    isLoadingSale: null,
    terminals:null,
    list_bank:null,
    list_bank_accounts:null
}

export const mutationTypes = {
    getListCashboxStart: '[cashbox] get list cashbox start',
    getListCashboxSuccess: '[cashbox] get list cashbox success',
    getListCashboxFailure: '[cashbox] get list cashbox failure',

    getCashboxDetailStart: '[cashbox] get cashbox detail start',
    getCashboxDetailSuccess: '[cashbox] get cashbox detail success',
    getCashboxDetailFailure: '[cashbox] get cashbox detail failure',

    openShiftStart: '[shift] open shift start',
    openShiftSuccess: '[shift] open shift success',
    openShiftFailure: '[shift] open shift failure',

    closeShiftStart: '[shift] close shift start',
    closeShiftSuccess: '[shift] close shift success',
    closeShiftFailure: '[shift] close shift failure',

    closeAcqStart: '[acq] close acq start',
    closeAcqSuccess: '[acq] close acq success',
    closeAcqFailure: '[acq] close acq failure',

    cashInStart: '[cashbox] cash in start',
    cashInSuccess: '[cashbox] cash in success',
    cashInFailure: '[cashbox] cash in failure',

    cashOutStart: '[cashbox] cash out start',
    cashOutSuccess: '[cashbox] cash out success',
    cashOutFailure: '[cashbox] cash out failure',

    xReportStart: '[cashbox] x report start',
    xReportSuccess: '[cashbox] x report success',
    xReportFailure: '[cashbox] x report failure',

    makePaymentStart: '[cashbox] make payment start',
    makePaymentSuccess: '[cashbox] make payment success',
    makePaymentFailure: '[cashbox] make payment failure',

    multiplePaymentStart: '[cashbox] multiple payment start',
    multiplePaymentSuccess: '[cashbox] multiple payment success',
    multiplePaymentFailure: '[cashbox] multiple payment failure',

    saleReceiptStart: '[receipt] sale receipt start',
    saleReceiptSuccess: '[receipt] sale receipt success',
    saleReceiptFailure: '[receipt] sale receipt failure',

    cancelReceiptStart: '[receipt] cancel receipt start',
    cancelReceiptSuccess: '[receipt] cancel receipt success',
    cancelReceiptFailure: '[receipt] cancel receipt failure',

    zReportStart: '[cashbox] z report start',
    zReportSuccess: '[cashbox] z report success',
    zReportFailure: '[cashbox] z report failure',

    makePaymentPartStart: '[cashbox] make payment Part start',
    makePaymentPartSuccess: '[cashbox] make payment Part success',
    makePaymentPartFailure: '[cashbox] make payment Part failure',

    saleReceiptPartStart: '[receipt] sale receipt Part start',
    saleReceiptPartSuccess: '[receipt] sale receipt Part success',
    saleReceiptPartFailure: '[receipt] sale receipt Part failure',

    multiplePaymentManyStart: '[cashbox] multiple payment many start',
    multiplePaymentManySuccess: '[cashbox] multiple payment many success',
    multiplePaymentManyFailure: '[cashbox] multiple payment many failure',

    saleReceiptBuyerStart: '[cashbox] Sale receipt buyer start',
    saleReceiptBuyerSuccess: '[cashbox] Sale receipt buyer success',
    saleReceiptBuyerFailure: '[cashbox] Sale receipt buyer failure',

    getListTerminalsStart: '[terminals] Get List Terminals start',
    getListTerminalsSuccess: '[terminals] Get List Terminals success',
    getListTerminalsFailure: '[terminals] Get List Terminals failure',

    createTerminalsStart: '[terminals] Create Terminals start',
    createTerminalsSuccess: '[terminals] Create Terminals success',
    createTerminalsFailure: '[terminals] Create Terminals failure',

    createCashboxStart: '[cashbox] Create cashbox start',
    createCashboxSuccess: '[cashbox] Create cashbox success',
    createCashboxFailure: '[cashbox] Create cashbox failure',

    getListBanksStart: '[list_bank] Get List Banks start',
    getListBanksSuccess: '[list_bank] Get List Banks success',
    getListBanksFailure: '[list_bank] Get List Banks failure',

    getListBanksAccountsStart: '[list_bank_accounts] Get List Banks Accounts start',
    getListBanksAccountsSuccess: '[list_bank_accounts] Get List Banks Accounts success',
    getListBanksAccountsFailure: '[list_bank_accounts] Get List Banks Accounts failure',
}

export const cashboxActionTypes = {
    getListCashbox: '[cashbox] get list cashbox',
    getCashboxDetail: '[cashbox] get cashbox detail',
    cashIn: '[cashbox] cash in',
    cashOut: '[cashbox] cash out',
    makePayment: '[cashbox] make payment',
    multiplePayment: '[cashbox] multiple payment',
    openShift: '[shift] open shift',
    closeShift: '[shift] close shift',
    closeAcq: '[acq] close acq',
    xReport: '[cashbox] x report',
    saleReceipt: '[receipt] sale receipt',
    cancelReceipt: '[receipt] cancel receipt',
    zReport: '[cashbox] z report',
    makePaymentPart: '[cashbox] make payment Part',
    saleReceiptPart: '[receipt] sale receipt Part',
    multiplePaymentMany: '[cashbox] multiple payment many',
    saleReceiptBuyer: '[cashbox] Sale receipt buyer',
    getListTerminals: '[terminals] Get List Terminals',
    createTerminals: '[terminals] Create Terminals',
    createCashbox: '[cashbox] Create Cashbox',
    getListBanks: '[list_bank] Get List Banks',
    getListBanksAccounts: '[list_bank_accounts] Get List Banks Account'
}

const mutations = {
    [mutationTypes.getListCashboxStart](state) {
        state.isLoading = true
        state.list = null
    },
    [mutationTypes.getListCashboxSuccess](state, payload) {
        state.isLoading = false
        state.list = payload
        state.validationErrors = null
    },
    [mutationTypes.getListCashboxFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getCashboxDetailStart](state) {
        state.isLoading = true
        state.cashbox = null
    },
    [mutationTypes.getCashboxDetailSuccess](state, payload) {
        state.isLoading = false
        state.cashbox = payload
        state.validationErrors = null
    },
    [mutationTypes.getCashboxDetailFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.openShiftStart](state) {
        state.isLoading = true
        state.opened = null
    },
    [mutationTypes.openShiftSuccess](state, payload) {
        state.isLoading = false
        state.opened = payload
        state.validationErrors = null
    },
    [mutationTypes.openShiftFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.closeShiftStart](state) {
        state.isLoading = true
        state.closed = null
    },
    [mutationTypes.closeShiftSuccess](state, payload) {
        state.isLoading = false
        state.closed = payload
        state.validationErrors = null
    },
    [mutationTypes.closeShiftFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.closeAcqStart](state) {
        state.isLoading = true
        state.acqClosed = null
    },
    [mutationTypes.closeAcqSuccess](state, payload) {
        state.isLoading = false
        state.acqClosed = payload
        state.validationErrors = null
    },
    [mutationTypes.closeAcqFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.cashInStart](state) {
        state.isLoading = true
        state.cashIn = null
    },
    [mutationTypes.cashInSuccess](state, payload) {
        state.isLoading = false
        state.cashIn = payload
        state.validationErrors = null
    },
    [mutationTypes.cashInFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.cashOutStart](state) {
        state.isLoading = true
        state.cashOut = null
    },
    [mutationTypes.cashOutSuccess](state, payload) {
        state.isLoading = false
        state.cashOut = payload
        state.validationErrors = null
    },
    [mutationTypes.cashOutFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.makePaymentStart](state) {
        state.doingPayment = true
        state.paid = null
        state.isLoading = true
    },
    [mutationTypes.makePaymentSuccess](state, payload) {
        state.doingPayment = false
        state.paid = payload
        state.validationErrors = null
        state.isLoading = false
    },
    [mutationTypes.makePaymentFailure](state,payload) {
        state.doingPayment = false
        state.validationErrors = payload
        state.isLoading = false
    },

    [mutationTypes.multiplePaymentStart](state) {
        state.doingPayment = true
        state.data = null
        state.isLoading = true
    },
    [mutationTypes.multiplePaymentSuccess](state, payload) {
        state.doingPayment = false
        state.data = payload
        state.validationErrors = null
        state.isLoading = false
    },
    [mutationTypes.multiplePaymentFailure](state,payload) {
        state.doingPayment = false
        state.validationErrors = payload
        state.isLoading = false
    },

    [mutationTypes.xReportStart](state) {
        state.isLoading = true
        state.xReport = null
    },
    [mutationTypes.xReportSuccess](state, payload) {
        state.isLoading = false
        state.xReport = payload
        state.validationErrors = null
    },
    [mutationTypes.xReportFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.saleReceiptStart](state) {
        state.isLoading = true
        state.receipt = null
    },
    [mutationTypes.saleReceiptSuccess](state, payload) {
        state.isLoading = false
        state.receipt = payload
        state.validationErrors = null
    },
    [mutationTypes.saleReceiptFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.cancelReceiptStart](state) {
        state.isLoading = true
        state.receiptCanceled = null
    },
    [mutationTypes.cancelReceiptSuccess](state, payload) {
        state.isLoading = false
        state.receiptCanceled = payload
        state.validationErrors = null
    },
    [mutationTypes.cancelReceiptFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.zReportStart](state) {
        state.isLoading = true
        state.zReport = null
    },
    [mutationTypes.zReportSuccess](state, payload) {
        state.isLoading = false
        state.zReport = payload
        state.validationErrors = null
    },
    [mutationTypes.zReportFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.makePaymentPartStart](state) {
        state.doingPayment = true
        state.paid = null
    },
    [mutationTypes.makePaymentPartSuccess](state, payload) {
        state.doingPayment = false
        state.paid = payload
        state.validationErrors = null
    },
    [mutationTypes.makePaymentPartFailure](state,payload) {
        state.doingPayment = false
        state.validationErrors = payload
    },

    [mutationTypes.saleReceiptPartStart](state) {
        state.isLoading = true
        state.receipt = null
    },
    [mutationTypes.saleReceiptPartSuccess](state, payload) {
        state.isLoading = false
        state.receipt = payload
        state.validationErrors = null
    },
    [mutationTypes.saleReceiptPartFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.multiplePaymenManytStart](state) {
        state.doingPayment = true
        state.data = null
        state.isLoading = true
    },
    [mutationTypes.multiplePaymentManySuccess](state, payload) {
        state.doingPayment = false
        state.data = payload
        state.validationErrors = null
        state.isLoading = false
    },
    [mutationTypes.multiplePaymentManyFailure](state,payload) {
        state.doingPayment = false
        state.validationErrors = payload
        state.isLoading = false
    },

    [mutationTypes.saleReceiptBuyerStart](state) {
        state.doingPayment = true
        state.isLoading = true
        state.isLoadingSale = true
        state.data = null
    },
    [mutationTypes.saleReceiptBuyerSuccess](state, payload) {
        state.doingPayment = false
        state.isLoading = false
        state.isLoadingSale = false
        state.data = payload
        state.validationErrors = null
    },
    [mutationTypes.saleReceiptBuyerFailure](state,payload) {
        state.doingPayment = false
        state.isLoading = false
        state.isLoadingSale = false
        state.validationErrors = payload
    },

    
    [mutationTypes.getListTerminalsStart](state) {
        state.terminals = null
        state.isLoading = true
    },
    [mutationTypes.getListTerminalsSuccess](state, payload) {
        state.terminals = payload
        state.isLoading = false
    },
    [mutationTypes.getListTerminalsFailure](state,payload) {
        state.validationErrors = payload
        state.isLoading = false
    },

    [mutationTypes.createTerminalsStart](state) {
        state.terminals = null
        state.isLoading = true
    },
    [mutationTypes.createTerminalsSuccess](state, payload) {
        state.terminals = payload
        state.isLoading = false
    },
    [mutationTypes.createTerminalsFailure](state,payload) {
        state.validationErrors = payload
        state.isLoading = false
    },

    [mutationTypes.createCashboxStart](state) {
        state.cashbox = null
        state.isLoading = true
    },
    [mutationTypes.createCashboxSuccess](state, payload) {
        state.cashbox = payload
        state.isLoading = false
    },
    [mutationTypes.createCashboxFailure](state,payload) {
        state.validationErrors = payload
        state.isLoading = false
    },

    [mutationTypes.getListBanksStart](state) {
        state.list_bank = null
        state.isLoading = true
    },
    [mutationTypes.getListBanksSuccess](state, payload) {
        state.list_bank = payload
        state.isLoading = false
    },
    [mutationTypes.getListBanksFailure](state,payload) {
        state.validationErrors = payload
        state.isLoading = false
    },

    [mutationTypes.getListBanksAccountsStart](state) {
        state.list_bank_accounts = null
        state.isLoading = true
    },
    [mutationTypes.getListBanksAccountsSuccess](state, payload) {
        state.list_bank_accounts = payload
        state.isLoading = false
    },
    [mutationTypes.getListBanksAccountsFailure](state,payload) {
        state.validationErrors = payload
        state.isLoading = false
    },
      
}

const actions = {
    [cashboxActionTypes.getListCashbox](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getListCashboxStart)
            cashboxApi
                .getListCashbox(data)
                .then(response => {
                    context.commit(mutationTypes.getListCashboxSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getListCashboxFailure, response)
                })
        })
    },
    [cashboxActionTypes.getCashboxDetail](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getCashboxDetailStart)
            cashboxApi
                .getCashboxDetail(data)
                .then(response => {
                    context.commit(mutationTypes.getCashboxDetailSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getCashboxDetailFailure, response)
                })
        })
    },
    [cashboxActionTypes.openShift](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.openShiftStart)
            cashboxApi
                .openShift(data)
                .then(response => {
                    context.commit(mutationTypes.openShiftSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.openShiftFailure, response)
                })
        })
    },
    [cashboxActionTypes.closeShift](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.closeShiftStart)
            cashboxApi
                .closeShift(data)
                .then(response => {
                    context.commit(mutationTypes.closeShiftSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.closeShiftFailure, response)
                })
        })
    },
    [cashboxActionTypes.closeAcq](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.closeAcqStart)
            cashboxApi
                .closeAcq(data)
                .then(response => {
                    context.commit(mutationTypes.closeAcqSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.closeAcqFailure, response)
                })
        })
    },
    [cashboxActionTypes.cashIn](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.cashInStart)
            cashboxApi
                .cashIn(data)
                .then(response => {
                    context.commit(mutationTypes.cashInSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.cashInFailure, response)
                })
        })
    },
    [cashboxActionTypes.cashOut](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.cashOutStart)
            cashboxApi
                .cashOut(data)
                .then(response => {
                    context.commit(mutationTypes.cashOutSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.cashOutFailure, response)
                })
        })
    },
    [cashboxActionTypes.makePayment](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.makePaymentStart)
            cashboxApi
                .makePayment(data)
                .then(response => {
                    context.commit(mutationTypes.makePaymentSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.makePaymentFailure, response)
                })
        })
    },
    [cashboxActionTypes.multiplePayment](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.multiplePaymentStart)
            cashboxApi
                .multiplePayment(data)
                .then(response => {
                    context.commit(mutationTypes.multiplePaymentSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.multiplePaymentFailure, response)
                })
        })
    },
    [cashboxActionTypes.xReport](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.xReportStart)
            cashboxApi
                .xReport(data)
                .then(response => {
                    context.commit(mutationTypes.xReportSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.xReportFailure, response)
                })
        })
    },
    [cashboxActionTypes.saleReceipt](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.saleReceiptStart)
            cashboxApi
                .saleReceipt(data)
                .then(response => {
                    context.commit(mutationTypes.saleReceiptSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.saleReceiptFailure, response)
                })
        })
    },
    [cashboxActionTypes.cancelReceipt](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.cancelReceiptStart)
            cashboxApi
                .cancelReceipt(data)
                .then(response => {
                    context.commit(mutationTypes.cancelReceiptSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.cancelReceiptFailure, response)
                })
        })
    },
    [cashboxActionTypes.zReport](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.zReportStart)
            cashboxApi
                .zReport(data)
                .then(response => {
                    context.commit(mutationTypes.zReportSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.zReportFailure, response)
                })
        })
    },
    [cashboxActionTypes.makePaymentPart](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.makePaymentPartStart)
            cashboxApi
                .makePaymentPart(data)
                .then(response => {
                    context.commit(mutationTypes.makePaymentPartSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.makePaymentPartFailure, response)
                })
        })
    },
    [cashboxActionTypes.saleReceiptPart](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.saleReceiptPartStart)
            cashboxApi
                .saleReceiptPart(data)
                .then(response => {
                    context.commit(mutationTypes.saleReceiptPartSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.saleReceiptPartFailure, response)
                })
        })
    },
    [cashboxActionTypes.multiplePaymentMany](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.multiplePaymentManyStart)
            cashboxApi
                .multiplePaymentMany(data)
                .then(response => {
                    context.commit(mutationTypes.multiplePaymentManySuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.multiplePaymentManyFailure, response)
                })
        })
    },
    [cashboxActionTypes.saleReceiptBuyer](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.saleReceiptBuyerStart)
            cashboxApi
                .saleReceiptBuyer(data)
                .then(response => {
                    context.commit(mutationTypes.saleReceiptBuyerSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypessaleReceiptBuyerFailure, response)
                })
        })
    },
    [cashboxActionTypes.getListTerminals](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getListTerminalsStart)
            cashboxApi
                .getListTerminals(data)
                .then(response => {
                    context.commit(mutationTypes.getListTerminalsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getListTerminalsFailure, response)
                })
        })
    },
    [cashboxActionTypes.createTerminals](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.createTerminalsStart)
            cashboxApi
                .createTerminals(data)
                .then(response => {
                    context.commit(mutationTypes.createTerminalsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.createTerminalsFailure, response)
                })
        })
    },

    [cashboxActionTypes.createCashbox](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.createCashboxStart)
            cashboxApi
                .createCashbox(data)
                .then(response => {
                    context.commit(mutationTypes.createCashboxSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.createCashboxFailure, response)
                })
        })
    },

    [cashboxActionTypes.getListBanks](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getListBanksStart)
            cashboxApi
                .getListBanks(data)
                .then(response => {
                    context.commit(mutationTypes.getListBanksSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getListBanksFailure, response)
                })
        })
    },

    [cashboxActionTypes.getListBanksAccounts](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getListBanksAccountsStart)
            cashboxApi
                .getListBanksAccounts(data)
                .then(response => {
                    context.commit(mutationTypes.getListBanksAccountsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getListBanksAccountsFailure, response)
                })
        })
    },
    
}

export default {
    state,
    actions,
    mutations
}